import { RRIBaseTableActionSettings } from './base-table-action-settings.interface';

export interface RRITableEditActionSettings<T>
  extends RRIBaseTableActionSettings {
  formatNavigateToUrl?: (row: T) => string;
}
